import { maxLength, required, schema, SchemaPathTree } from '@angular/forms/signals';
import { ICreateOrganizationModel } from '../../models/portal-core-features/create-organization.model';

export const createOrganizationSchema = schema((path: SchemaPathTree<ICreateOrganizationModel>) => {
  required(path.name, { message: 'VALIDATION_MESSAGES.REQUIRED' });
  maxLength(path.name, 50, { message: 'CREATE_ORGANIZATION.NAME_MAX_LENGTH_ERROR' });
});
